export default function SingleSiteHeader({site}) {
  return <div className="text-xl font-semibold">{site.name}</div>;
}
